module.exports = __webpack_public_path__ + "img/hand-pointing-back.dd38acaa.svg";